module.exports = __webpack_public_path__ + "static/media/sfl_5.9dcf399b.jpg";